import { Component, inject, OnInit } from '@angular/core';
import { ConfigurationService } from '@services/configuration/configuration.service';

@Component({
  selector: 'app-bouton-retour-accueil',
  templateUrl: './bouton-retour-accueil.component.html',
  standalone: false,
})
export class BoutonRetourAccueilComponent implements OnInit {
  private readonly configService = inject(ConfigurationService);
  urlAccueil!: string;

  ngOnInit() {
    this.urlAccueil = this.configService.getValueOrBlank(
      configuration.ConfigMeta.OEL_FERMETURE_URL,
    );
  }
}
